/* eslint-disable promise/param-names */
import {
  STATS_REQUEST,
  STATS_SUCCESS,
  STATS_REPLACE
} from '@/store/actions/stats'

import firebase from 'firebase/app'
import 'firebase/firestore'
import Vue from 'vue'
import moment from 'moment';

const state = { 
  stats: [],
  status: '', 
  hasLoadedOnce: false,
};

const getters = {
  stats: state => state.stats ? state.stats : [],
  statsLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [STATS_REQUEST]: ({commit, dispatch}) => {
    if (!state.hasLoadedOnce) {
      return new Promise((resolve, reject) => {
        commit(STATS_REQUEST)
      
        const monthAgo = new Date( Math.ceil(moment().add(-1, 'month').format('x')) );

        firebase.firestore().collection('stats')
          .where("createdAtDay", ">", monthAgo)
          .orderBy('createdAtDay')
          .onSnapshot(querySnapshot => {
            let stats = []

            querySnapshot.docChanges().forEach(change => {
              stats.push(change.doc.data())
            })

            if (state.hasLoadedOnce == false) {
              commit(STATS_SUCCESS, stats)
            } else {
              commit(STATS_REPLACE, stats)
            }

            resolve();
          })
      })
    }
  },
}

const mutations = {
  [STATS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [STATS_SUCCESS]: (state, stats) => {
    state.status = 'success';
    state.stats = stats;
    state.hasLoadedOnce = true;
  },

  [STATS_REPLACE]: (state, stats) => {
    stats.forEach(stat => {
      let rowIndex = state.stats.findIndex(elem => elem.createdAtDay.seconds == stat.createdAtDay.seconds)
      if (rowIndex != -1) {
        Vue.set(state.stats, rowIndex, stat)
      } else {
        state.stats.push(stat)
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
